import Network from '@/views/network'
import Company from '@/views/company'
import Group from '@/views/group'
import User from '@/views/user'
import Statistic from '@/views/statistic'
import Auth from '@/views/auth'

const Dashboard = () => import('@/views/Dashboard.vue')
const PageNotFound = () => import('@/views/PageNotFound.vue')

export { Dashboard, PageNotFound, Auth, Network, Company, Group, User, Statistic }
